import { useNavigate } from 'react-router-dom';
import { Clock, Server, ChevronRight } from 'lucide-react';
import type { ISPDownClient } from '../types';

interface Props {
  client: ISPDownClient;
}

export function ISPClientItem({ client }: Props) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (client.hasAccess) {
      navigate(`/visits/client/${client.sobid}`);
    }
  };

  return (
    <button
      onClick={handleClick}
      disabled={!client.hasAccess}
      className={`w-full text-left p-2 rounded-md transition-colors ${
        client.hasAccess
          ? 'hover:bg-muted/50 cursor-pointer'
          : 'cursor-not-allowed'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          {client.hasAccess && (
            <div className="flex items-center gap-1.5 text-sm font-medium">
              <span className="truncate">{client.name}</span>
            </div>
          )}

          {client.hasAccess && client.linuxhostname && (
            <div className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5">
              <Server className="h-3 w-3" />
              <span className="truncate">{client.linuxhostname}</span>
            </div>
          )}

          <div className="flex items-center gap-1 text-xs text-muted-foreground mt-0.5">
            <Clock className="h-3 w-3" />
            <span>{client.diff}</span>
            <span className="text-muted-foreground/70">
              с {new Date(client.down).toLocaleString('ru-RU', {
                day: '2-digit',
                month: '2-digit',
                hour: '2-digit',
                minute: '2-digit',
              })}
            </span>
          </div>
        </div>

        {client.hasAccess && (
          <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0 mt-1" />
        )}
      </div>
    </button>
  );
}
